import React from 'react'
import VendorDetails from '../vendorDetails/VendorDetails';
import { Route, Routes } from 'react-router-dom';
import UpdateVendor from '../vendorDetails/UpdateVendor';

const VendorRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/details" element={<VendorDetails />} />
                <Route path="/update-detail" element={<UpdateVendor />} />
            </Routes>
        </>
    )
}

export default VendorRoutes;